module.exports = __webpack_public_path__ + "static/media/Path Copy 2.71e961ce.png";